/**
 * Organisms - Complex UI components made of molecules and atoms
 * Examples: Header, Footer, Sidebar, NavigationBar, LoginForm, ProductCard
 * These form distinct sections of an interface
 *
 * 재노출은 **바깥에서 실제로 쓰는 심볼만** 명시한다 — `export *` 로 폴더를 통째로 내보내면
 * 소비처 0건인 컴포넌트가 배럴 한 줄 뒤에서 살아 있는 코드처럼 보인다(가드:
 * `src/__tests__/sharedUiBarrelReexportGuard.test.ts`). organisms 안에서만 쓰는 것은
 * 상대 경로로 가져다 쓰고 여기 싣지 않는다 — CheckInCenter·WeeklyAttendanceList 는
 * AttendanceDashboard 가, PasswordChangeModal 은 StatusHud 가 그렇게 쓴다.
 */

export { LiquidGlassFilter, useGlassHover } from './LiquidGlass';
export {
  LuminariumBackdrop,
  concealLuminarium,
  useLuminariumReveal,
  setVeilPanel,
} from './LuminariumBackdrop';
export type { LuminariumBackdropProps } from './LuminariumBackdrop';
export { AttendanceDashboard } from './AttendanceDashboard';
export { MonthlyCalendarHeatmap } from './MonthlyCalendarHeatmap';
export { QuestAcceptModal } from './QuestAcceptModal';
export type { QuestAcceptModalProps } from './QuestAcceptModal';
export { QuickNav } from './QuickNav';
export { ProofRejectModal, proofRejectStyles } from './ProofRejectModal';
export type { ProofRejectModalProps } from './ProofRejectModal';
export { CheckOutModal } from './CheckOutModal';
export type { CheckOutModalProps } from './CheckOutModal';
export type { StatusHudProps } from './StatusHud';
export { PanelModalShell } from './PanelModalShell';
export type { PanelModalShellProps } from './PanelModalShell';
